import { useEffect } from 'react';
import { setPageTitle } from '@/stores/ui.store.ts';

type PageProps = {
  title?: string;
};
export const usePageProps = (props: PageProps) => {
  useEffect(() => {
    setTimeout(() => {
      if (props.title) {
        setPageTitle(props.title);
      }
    });
  }, [props]);
};
